// extracted by mini-css-extract-plugin
export default {"infoNote":"jdwnWd71dgw9wXUda3qM","dark":"Nc2zBXIV_oMKVXqb5KBA","list":"RVrCfXYoVQjjPyDa8WNE"};